import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-x-20 gap-y-x3 min-h-320 pt-2 pb-10 sm:grid-cols-3 lg:gap-y-x5 lg:grid-cols-4 min-h-350" }

import CustomizerOverlay from '@/shared/product/customizer/ui/overlays/CustomizerOverlay.vue';
import useCustomizer from '@/shared/product/customizer/useCustomizer';
import { computed, ref, watch } from 'vue';
import { CustomizerTabType, ProductSpotModel } from '@/types/productServerApi';
import ProductFamilySpot from '@/shared/product/customizer/ui/spots/ProductFamilySpot.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import useProductDetailData from '@/shared/product/details/useProductDetailData';
import authStore from '@/shared/auth/auth.store';
import useNetPrices from '@/b2b/product/useNetPrices';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFamily',
  setup(__props) {

const labels = useBlockLabels();
const { fetchNetPrices } = useNetPrices();
const { activeCustomizerOverlayType, activeCustomizerOverlayId, clearActiveCustomizerOverlay, getProductFamilyCustomizers } = useCustomizer();
const { familyName } = useProductDetailData();

const isActive = computed<boolean>(() => activeCustomizerOverlayType.value === CustomizerTabType.ProductFamily);

const items = ref<ProductSpotModel[]>([] as ProductSpotModel[]);

const getOrClearData = async(active) => {
    if (active) {
        items.value = await getProductFamilyCustomizers(activeCustomizerOverlayId.value);
    } else {
        items.value.length = 0;
    }
};

const fetchNetPriceForItems = () => {
    if (isSignedInAsPartner.value) {
        fetchNetPrices(items.value.map((item) => item.sku));
    }
};

const isSignedInAsPartner = computed<boolean>(() => {
    return authStore.isSignedInAsPartner;
});

watch(isActive, getOrClearData, { immediate: true });
watch(items, fetchNetPriceForItems, { immediate: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomizerOverlay, {
    "is-open": _unref(isActive),
    title: _ctx.$dictionary.formatNamed(_unref(labels).overlayFamilyHeader, { name: _unref(familyName) }),
    onClose: _unref(clearActiveCustomizerOverlay)
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
          return (_openBlock(), _createBlock(ProductFamilySpot, {
            key: item.sku,
            item: item
          }, null, 8, ["item"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["is-open", "title", "onClose"]))
}
}

})